export type InfoAboutAction =
  | { type: 'SET_IS_FETCHING_ABOUT_CONTENT' }
  | { type: 'SET_FETCH_ABOUT_CONTENT_FAILED' }
  | { type: 'SET_ABOUT_CONTENT', content: Julius.Website.AboutPageViewModel };

  export const setIsFetching = (): InfoAboutAction => ({
    type: 'SET_IS_FETCHING_ABOUT_CONTENT',
  });

  export const setFetchFailed = (): InfoAboutAction => ({
    type: 'SET_FETCH_ABOUT_CONTENT_FAILED',
  });

  export const setAboutContent = (content: Julius.Website.AboutPageViewModel): InfoAboutAction => ({
    content,
    type: 'SET_ABOUT_CONTENT',
  });


// WEBPACK FOOTER //
// ./src/components/InfoAbout/Redux/actions.tsx